import React from 'react'
import { BLOCKS, MARKS } from '@contentful/rich-text-types'
import { documentToReactComponents } from '@contentful/rich-text-react-renderer'
import EcoClearLogo from '../../components/svg/ecoClearLogo'

import {
	HeroSection,
	HeroItemsContainer,
	HeroButtons,
	HeroSeeAllLink,
	HeroSeeAll,
	HeroBookLink,
	HeroBook,
	Bold,
	Heading1,
	BannerText,
} from './styles'

const Hero = ({
	mainActionText,
	mainActionUrl,
	secondActionText,
	secondActionUrl,
	description,
	bannerSources,
}) => {
	const heroBannerOptions = {
		renderMark: {
			[MARKS.BOLD]: text => <Bold>{text}</Bold>,
		},
		renderNode: {
			[BLOCKS.HEADING_1]: (node, children) => <Heading1>{children}</Heading1>,
			[BLOCKS.PARAGRAPH]: (node, children) => (
				<BannerText>{children}</BannerText>
			),
		},
	}

return (
	<HeroSection sources={bannerSources}>
		<HeroItemsContainer sources={bannerSources}>
			<EcoClearLogo size="600" primary="#59c2d9" secondary="#5885a3"/>
			{documentToReactComponents(description.json, heroBannerOptions)}
		</HeroItemsContainer>
	</HeroSection>
)
}

export default Hero
